// extracted by mini-css-extract-plugin
export default {"logoImage":"logo_logoImage__bh0Ep"};